import React, { useMemo, useState } from 'react';
import { products } from '../data/products';
import { Category } from '../types/product';
import { ProductCard } from './ProductCard';
import { useScreenInit } from '../useScreenInit.js';
type Filter = 'all' | Category;
const filters: {
  id: Filter;
  label: string;
}[] = [{
  id: 'all',
  label: 'Everything'
}, {
  id: 'night-suits',
  label: 'Night Suits'
}, {
  id: 't-shirts',
  label: 'T-Shirts'
}];
export function Collection() {
  const screenInit = useScreenInit();
  const [filter, setFilter] = useState<Filter>(screenInit?.filter as Filter ?? 'all');
  const visible = useMemo(() => filter === 'all' ? products : products.filter(p => p.category === filter), [filter]);
  return <section id="collection" className="bg-bone" data-id="element-86" data-mp="39zrun9b705ts">
      <div className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-32" data-id="element-87" data-mp="23khjmb2nv0wa">
        <div className="flex flex-col gap-8 border-b border-greige/70 pb-8 md:flex-row md:items-end md:justify-between" data-id="element-88" data-mp="23ieh4rkbnfao">
          <div data-id="element-89" data-mp="ugyqmtjhm8fs">
            <p className="eyebrow text-clay" data-id="element-90" data-mp="ugfbfkl81y5g">The Collection</p>
            <h2 className="mt-4 font-display text-4xl font-light leading-tight text-ink lg:text-5xl" data-id="element-91" data-mp="uevvxw7e3r4q">
              Six pieces, considered
            </h2>
            <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-smoke" data-id="element-92" data-mp="khr5vlafbbin">
              Every piece is offered in a women's and a men's cut, in the same three colours. Night
              sets ₹5,000, tees ₹3,000 — introductory prices, held all season. We do not discount.
            </p>
          </div>
          <div className="flex flex-wrap gap-6" role="tablist" aria-label="Filter collection" data-id="element-93" data-mp="giqn22ry48vn">
            {filters.map(f => <button key={f.id} role="tab" aria-selected={filter === f.id} onClick={() => setFilter(f.id)} className={`eyebrow relative pb-1 transition-colors ${filter === f.id ? 'text-ink' : 'text-smoke hover:text-ink'}`} data-id="element-94" data-mp="1qgg57gfp4sc">
                {f.label}
                <span className={`absolute inset-x-0 bottom-0 h-px origin-left bg-ink transition-transform duration-500 ${filter === f.id ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-95" data-mp="1zhycwkxylvvy" />
              </button>)}
          </div>
        </div>

        {visible.length === 0 ? <p className="py-24 text-center text-sm font-light text-smoke" data-id="element-96" data-mp="2iezk8cezk832">
            Nothing in this category just now. Please check back shortly.
          </p> : <div className="grid gap-x-8 gap-y-16 pt-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-97" data-mp="28gjqs2shkmqe">
            {visible.map((product, i) => <ProductCard key={product.id} product={product} index={i} data-id="element-98" data-mp="24dwvfrwlwjog" data-mpi={i} />)}
          </div>}
      </div>
    </section>;
}